
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcVideoOnlyPage from '../../blocks/PcVideoOnlyPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { BAIDU02_DOWNLOAD_URLS, BAIDU_DOWNLOAD_CONFIGS } from '../../config/downloadUrls';
import { LandingProps, PcVideoOnlyProps } from '../../config/types';
import { setupPage } from '../../utils/setupPage';

@Component({
  components: { DeviceLayout, PcVideoOnlyPage, MobilePage },
})
export default class Baidu02Page extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: BAIDU02_DOWNLOAD_URLS,
    hideList: false,
    showAppInfo: true,
    isBaiduDeveloper: true,
    showAddress: false,
    baiduApiToken: BAIDU_DOWNLOAD_CONFIGS.BAIDU02,
  };

  get pcProps(): PcVideoOnlyProps {
    return {
      downloadUrls: this.landingProps.downloadUrls,
      showAppInfo: this.landingProps.showAppInfo,
      isBaiduDeveloper: this.landingProps.isBaiduDeveloper,
      showAddress: this.landingProps.showAddress,
      baiduApiToken: this.landingProps.baiduApiToken,
      videoSrc: require('@/assets/video/rj01.mp4'),
    };
  }

  public mounted() {
    setupPage({
      documentTitle: '海南指趣互娱信息科技有限公司天津分公司',
      baiduTracking: true,
    });
  }
}
